import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["font", "icon", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var fonts = ['gizmo', 'standard', 'social', 'nerdwallet', 'material']; // Warn about use of deprecated font icons

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
  console.warn('Using deprecated font icons! It is recommended to use the SVG version of icons. See http://docs.nerdwallet.io/react-icon/branches/master for suggested usage info.');
}

var Icon = function Icon(_ref) {
  var font = _ref.font,
      icon = _ref.icon,
      className = _ref.className,
      transferrableProps = _objectWithoutProperties(_ref, _excluded);

  var classes = ['icon'];
  var body = '';

  if (font === 'nerdwallet') {
    classes.push('nw-icon');
    classes.push("nw-".concat(icon));
  } else if (font === 'material') {
    classes.push('nw-material');
    body = icon;
  } else if (icon) {
    classes.push("ss-".concat(font || 'gizmo'));
    classes.push("ss-".concat(icon));
  }

  classes.push(className);
  var props = {
    className: classNames(classes),
    'aria-hidden': true
  };
  return /*#__PURE__*/React.createElement("span", _extends({}, transferrableProps, props), body);
};

Icon.displayName = 'nw-icon';
Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  font: PropTypes.oneOf(fonts)
  /**
   * Any further props will be passed to the icon <span>!
   */

};
Icon.defaultProps = {
  className: null,
  icon: null,
  font: null
};
export default Icon;